// extracted by mini-css-extract-plugin
module.exports = {"thank-you-content":"thankYouContent_thank-you-content__Lo8M8"};